export function trackEvent(name, params = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: name, ...params });
  if (typeof window.fbq === "function") {
    window.fbq("trackCustom", name, params);
  }
  if (typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
}

export function trackAmazonClick(location) {
  trackEvent("click_amazon", { location, url: "https://amzn.eu/d/01pW9tnS" });
}

export function trackLead(source) {
  const params = { source, content_name: "Guida gratuita al vino", content_category: "lead_magnet" };
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "generate_lead", ...params });
  if (typeof window.fbq === "function") {
    window.fbq("track", "Lead", params);
  }
  if (typeof window.gtag === "function") {
    window.gtag("event", "generate_lead", params);
  }
}

export function loadAnalytics(ga4Id, metaPixelId) {
  if (ga4Id && !document.getElementById("ga4-script")) {
    const s = document.createElement("script");
    s.id = "ga4-script";
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${ga4Id}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", ga4Id);
  }
  if (metaPixelId && !window.fbq) {
    const n = (window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    });
    n.queue = [];
    n.version = "2.0";
    const t = document.createElement("script");
    t.async = true;
    t.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(t);
    window.fbq("init", metaPixelId);
    window.fbq("track", "PageView");
  }
}
